/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-10 14:41:14
 * @LastEditors: yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-07-15 15:34:36
 * @FilePath: \MPC-monorepo\features\mpc-common\src\features\MPCDemand\enum.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useMemo } from 'react';
import { Tag } from '@bedrock/components';

export const contractMethodOptions = [
    {
        name: '复用合同',
        value: 'REUSE'
    },
    {
        name: '新建合同-自动生成合同',
        value: 'NEW_CREATE_ONLINE'
    },
    {
        name: '新建合同-人工上传合同',
        value: 'NEW_CREATE_MANUAL'
    },
    {
        value: 'NO_NEED',
        name: '无需合同',
    },
]

export function getContractMethodOptions(checked_amount: number) {
    return [
        {
            name: '复用合同',
            value: 'REUSE'
        },
        {
            name: '新建合同-自动生成合同',
            value: 'NEW_CREATE_ONLINE'
        },
        {
            name: '新建合同-人工上传合同',
            value: 'NEW_CREATE_MANUAL'
        },
        {
            value: 'NO_NEED',
            showName: '无需合同',
            name: <>
                <div>无需合同</div>
                <div>中选金额&lt;=50,000.00人民币时可选择</div>
            </>,
            disabled: checked_amount > 50000,
        },
    ]
}

export function ContractMethodTag(props: {
    value: string;
}) {
    const { value } = props;
    const tag = useMemo(() => {
        if(!value) return '--';
        const tagText = contractMethodOptions.find(item => item.value === value)?.name;
        switch (value) {
            case 'REUSE':
                return <Tag size="small" color="light-blue" text={tagText} />;
            case 'NEW_CREATE_ONLINE':
            case 'NEW_CREATE_MANUAL':
                return <Tag size="small" color="light-green" text={tagText} />;
            case 'NO_NEED':
            default:
                return <Tag size="small" color="light-grey" text={tagText} />;
        }
    }, [value]);
    return <>{tag}</>;
}

export const booleanOptions = [
    {
        name: '是',
        value: true
    },
    {
        name: '否',
        value: false
    },
]


export enum MPCProcessNodeEnum {
    /**
     * 新建
     */
    NEWLY_BUILT = 'newly_built',
  
    /**
     * OA前置审批
     */
    PRE_APPROVE = 'pre_approve',
  
    /**
     * 待策划设计
     */
    PENDING_DESIGN = 'pending_design',
  
    /**
     * 比选中
     */
    PENDING_BIDDING = 'pending_bidding',
  
    /**
     * 待评估
     */
    PENDING_ASSESS = 'pending_assess',
  
    /**
     * 待报价
     */
    PENDING_QUOTE = 'pending_quote',
  
    /**
     * 综合询比价
     */
    QUOTE_SCORE = 'quote_score',
  
    /**
     * 报价待商务确认
     */
    BUSINESS_AUDIT_QUOTE = 'business_audit_quote',
  
    /**
     * 报价待商务确认
     */
    BUSINESS_LEADER_AUDIT_QUOTE = 'business_leader_audit_quote',
  
    /**
     * 报价待策划确认
     */
    PLANNER_AUDIT_QUOTE = 'planner_audit_quote',
  
    /**
     * 策划负责人确认
     */
    PLANNER_LEADER_AUDIT_QUOTE = 'planner_leader_audit_quote',
  
    /**
     * 报价待需求方确认
     */
    MARKETING_AUDIT_QUOTE = 'marketing_audit_quote',
  
    /**
     * 报价待需求方负责人确认
     */
    MARKETING_LEADER_AUDIT_QUOTE = 'marketing_leader_audit_quote',
  
    /**
     * OA定标审批
     */
    FEE_APPROVE = 'fee_approve',
  
    /**
     * 制作中
     */
    MAKING = 'making',
  
    /**
     * 绑定数据节点
     */
    BIND_EXECUTION_DATA = 'bind_execution_data',
  
    /**
     * 进行中
     */
    UNDERWAY = 'underway',
  
    /**
     * 策划复核
     */
    PLANNER_ACCEPT = 'planner_accept',
  
    /**
     * 策划负责人复核
     */
    PLANNER_LEADER_ACCEPT = 'planner_leader_accept',
  
    /**
     * 商务验收
     */
    BUSINESS_ACCEPT = 'business_accept',
  
    /**
     * 需求方验收
     */
    DEMANDER_ACCEPT = 'demander_accept',
  
    /**
     * 需求方负责人验收
     */
    APPROVE_SETTLE = 'approve_settle',
  
    /**
     * 结案材料验收复核
     */
    QC_ACCEPT = 'qc_accept',
  
    /**
     * 营销业务验收与结算
     */
    SUBMIT_OA = 'submit_oa',
  
    /**
     * 提交付款
     */
    SUBMIT_REIMBURSE = 'submit_reimburse',
  
    /**
     * 关闭
     */
    CLOSED = 'closed',
  
    /**
     * 废弃
     */
    ABANDON = 'abandon'
  }